import { createGlobalState } from '@vueuse/core'

export function useSingleton(createInstance = () => {}) {
  return createGlobalState(createInstance)
}
